import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "ddd-complete-new-cycle-first-visit",
  templateUrl: "./complete-new-cycle-first-visit.component.html",
  styleUrls: ["./complete-new-cycle-first-visit.component.scss"],
  standalone: true
})
export class CompleteNewCycleFirstVisitComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CompleteNewCycleFirstVisitComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public dialog: any;

  ngOnInit() {
    return;
  }
}
